import { useViewport } from '@zopauk/react-components';
import { TelephoneCard as Card } from '@/components/TelephoneCard';
import type { TelephoneCardFragment } from '@/utils/dato/generated';

const MOBILE_BREAKPOINT = 768;

const TelephoneCard = ({
  nonIndexedPage,
  telephoneLink,
  telephoneText,
  description,
  identifier,
  title,
}: TelephoneCardFragment) => {
  const { width } = useViewport();
  const validTelephoneText = telephoneText || '';

  if ((width ?? 0) <= MOBILE_BREAKPOINT || !nonIndexedPage) {
    return (
      <Card
        {...{
          telephoneText: validTelephoneText,
          telephoneLink,
          description,
          identifier,
          title,
        }}
      />
    );
  }

  const linkWithHash =
    nonIndexedPage.slug != null ? `/${nonIndexedPage.slug}${identifier ? `#${identifier}` : ''}` : telephoneLink;

  return (
    <Card
      {...{
        telephoneText: telephoneText ?? '',
        telephoneLink: linkWithHash,
        description,
        identifier,
        title,
      }}
    />
  );
};

export default TelephoneCard;
